import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import { Spin } from "antd";
import { setloggedIn, setUserDetails } from "../../store/Slices/userSlice";
import { clearCookies, setCookies } from "../../services/Cookies";
import { SuperAdminLoginApi } from "../../api/request/auth";

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);

  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const getUser = async (id, token) => {
    try {
      const apiHeader = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await SuperAdminLoginApi({ admin_id: id }, apiHeader);
      if (data?.status) {
        setCookies("token", data?.token);
        dispatch(setloggedIn(true));
        dispatch(setUserDetails(data?.data));
        navigate("/dashboard");
      }
    } catch (error) {
      navigate("/");
    }
  };

  useEffect(() => {
    clearCookies();
  }, []);

  useEffect(() => {
    const encrypted = decodeURIComponent(queryParams.get("token"));
    const decrypted = CryptoJS.AES.decrypt(encrypted, secretKey);
    const data = decrypted.toString(CryptoJS.enc.Utf8);
    const { token, AdminId } = JSON.parse(data);
    getUser(AdminId, token);
  }, [queryParams]);

  return (
    <div className="flex flex-col justify-center items-center gap-2 h-screen">
      <Spin />
      <p className="text-secondaryLight1">Loading...</p>
    </div>
  );
};

export default SuperAdminLogin;
